import React, { useState } from 'react'
import {
  WbInputControl,
  WbInput,
  WbControlError,
  WbControlHint,
  WbIcon,
  WbDatepickerControl,
} from '@workbench/react/dist'
import cn from 'classnames'
import classes from './InputField.module.scss'
import { useTranslation } from 'react-i18next'

interface InputFieldProps {
  id?: string
  label?: string
  hint?: string
  error?: string
  disabled?: boolean
  textarea?: boolean
  className?: string
  minDate?: string
  maxDate?: string
  type?: JSX.IntrinsicElements['input']['type']
  inputProps?:
    | JSX.IntrinsicElements['input']
    | JSX.IntrinsicElements['textarea']
}

export const InputField: React.FunctionComponent<InputFieldProps> = ({
  id,
  label,
  hint,
  textarea,
  error,
  className,
  minDate,
  maxDate,
  ...inputProps
}) => {
  const { t } = useTranslation()
  const [showPassword, setShowPassword] = useState<boolean>(false)
  if (inputProps.type === 'wb-date') {
    return (
      <WbDatepickerControl
        minDate={minDate}
        maxDate={maxDate}
        className={cn(classes.field, className)}
      >
        <WbInputControl className={cn(classes.dateInputControl)}>
          <WbInput>
            <label htmlFor={id}>{label}</label>
            <input id={id} {...inputProps} type="date" />
          </WbInput>
          {hint && <WbControlHint>{hint}</WbControlHint>}
          {error && <WbControlError>{error}</WbControlError>}
        </WbInputControl>
      </WbDatepickerControl>
    )
  }
  return (
    <WbInputControl className={cn(classes.field, className)}>
      <WbInput>
        <label htmlFor={id}>{label}</label>
        {textarea ? (
          <textarea id={id} {...inputProps} />
        ) : (
          <input
            id={id}
            {...inputProps}
            type={
              inputProps.type === 'password' && showPassword
                ? 'text'
                : inputProps.type
            }
          />
        )}

        {inputProps.type === 'password' && (
          <WbIcon
            className={classes.passwordIcon}
            onClick={() => setShowPassword((s) => !s)}
            name={showPassword ? 'no-eye' : 'eye'}
            role="button"
            aria-pressed={showPassword ? 'true' : 'false'}
            aria-label={t('components.inputs.inputField.showPassword')}
          />
        )}
      </WbInput>

      {hint && <WbControlHint>{hint}</WbControlHint>}
      {error && <WbControlError>{error}</WbControlError>}
    </WbInputControl>
  )
}
